import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { AboutComponent } from './about.component';

const routes: Routes = [
  {
    path: 'about',
    canActivate: [AuthorizeGuard],
    component: AboutComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AboutRoutingModule {}
